import { Fragment, useContext, useMemo, useState, useEffect } from "react";
import axios from "axios";

import Person from "./components/person/person.component";
import Company from "./components/company/company.component";
import NewProfileModal from "./components/new-profile-modal/new-profile-modal.component";

import { AuthContext } from "src/contexts/auth.context";

import { COLORS, POSITIONS } from "utils/lists.utils";

import "./people.style.scss";
import { getItemWhere } from "utils/array.utils";
import useTranslate from "src/hooks/use-translate";

// const LIST = ["Administrator", "Member"];

// const COMPANIES = [
// 	{
// 		company: {
// 			companyColor: "#5856D6",
// 		},
// 		users: [
// 			{ name: "Jane", surname: "Doe", jobTitle: "Expert Accountant", position: 0 },
// 			{ name: "Victoria", surname: "DeAngelis", jobTitle: "Accountant", position: 1 },
// 			{ name: "Ethan", surname: "Torchio", jobTitle: "Accountant Intern", position: 1 },
// 			{ name: "Thomas", surname: "Raggi", jobTitle: "Accountant Intern", position: 1 },
// 		],
// 	},
// ];

const CLIENTS = [
	{
		companyType: 0,
		name: "Kate",
		surname: "Bush",
		username: "_KateBush",
		vatNumber: "UK 4444444444",
		jobTitle: "Singer",
		email: "katebush@gmail.com",
		phone: "+44 7700 900651",
		country: "United Kingdom",
		city: "London",
		address: "Upside Hill Street 99",
		zipCode: "1978",
		id: "123",
		createdAt: "September 19, 2003",
		color: COLORS[1],
		subscription: 0,
		archivePeriod: 1,
		safeLockingPeriod: 2,
		liveChat: 0,
		mobile: 0,
		filler: { done: 100, message: 20, invoices: 13 },
	},
	{
		companyType: 1,
		company: {
			name: "Spotify",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[2],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010929",
		filler: { done: 100, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane",
				surname: "Doe",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole",
				surname: "Kidman",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl",
				surname: "Streep",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano",
				surname: "David",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Nicole",
				surname: "Kidman",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Linkedin",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[4],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010929",
		filler: { done: 10, message: 200, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "UnitedHealth Group",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[3],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010921",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Walmart",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[3],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010929",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Berkshire Hathaway",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[5],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010923",
		filler: { done: 10, message: 20, invoices: 130 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Costco Wholesale",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[7],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010929",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Elevance Health",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[3],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010927",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Valero Energy",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[4],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010950",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Dell Technologies",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[4],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010950",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Netflix",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[7],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010950",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Coca Cola Company",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[7],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010950",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "FedEx",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[5],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010950",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
];

const sortEmployeeList = (list) => {
	const admins = list.filter((person) => person.position === 0);
	const members = list.filter((person) => person.position === 1);

	return [...admins, ...members];
};

const People = () => {
	const {
		user: { position, userId, firmId, color },
	} = useContext(AuthContext);

	const t = useTranslate("Account");

	const [peopleList, setPeopleList] = useState([]);
	// const [peopleList, setPeopleList] = useState(sortEmployeeList(COMPANIES[0].users));
	const [selectedIndex, setSelectedIndex] = useState(-1);
	const [isNewMemberModalVisible, setIsNewMemberModalVisible] = useState(false);

	useEffect(() => {
		axios
			.get(`/getMembers`, {
				params: {
					userId,
					firmId,
				},
			})
			.then(({ data }) => {
				setPeopleList(sortEmployeeList(data));
			})
			.catch(console.log);
		// axios.get(`/getMembers/userId=${userId}&firmId=${firmId}`).then(console.log).catch(console.log);
	}, [userId, firmId]);

	const isAdmin = useMemo(() => position === 0, [position]);

	const accountants = useMemo(() => peopleList, [peopleList]);
	// const accountants = COMPANIES[0].users;

	const handleOpenModal = () => {
		setIsNewMemberModalVisible(true);
	};
	const handleCloseModal = () => {
		setIsNewMemberModalVisible(false);
	};

	const handleRemove = (deletedUserId) => {
		console.log({ deletedUserId });

		axios
			.post("/deleteAccount", { userId, firmId, userToDelete: deletedUserId })
			.then(console.log)
			.catch(console.error);

		setPeopleList((oldValue) => {
			const newValue = oldValue.filter(({ userId: _userId }) => _userId !== deletedUserId);
			return newValue;
		});
	};

	const handleAddNewMember = (newProfile) => {
		axios.post("/newMember", newProfile).then(console.log).catch(console.error);

		setPeopleList((oldValue) => {
			const newValue = [...oldValue];
			newValue.push(newProfile);
			return sortEmployeeList(newValue);
		});
	};

	const handleClickOnRow = (index) => {
		if (selectedIndex === index) {
			setSelectedIndex(-1);
			return;
		}
		setSelectedIndex(index);
	};

	return (
		<div className="people-container">
			<span className="size600 w600 with-line">People</span>
			<div className="data-wrapper scroll-bar scroll-bar--overflow">
				<div className="flex flex--column margin-m--bottom">
					{peopleList.map((person, index) => {
						const fullName = person.name + " " + person.surname;
						return (
							<Fragment key={index}>
								<div
									name="accordion-row"
									className={`person-wrapper padding-s--block padding-m--inline border--bottom ${
										index === selectedIndex && "expanded-title"
									}`}
								>
									<Person
										onClick={() => handleClickOnRow(index)}
										index={index}
										id={person.userId}
										name={fullName}
										jobTitle={person.jobTitle}
										position={POSITIONS[person.position]}
										color={color}
										isAdmin={isAdmin}
										onRemove={handleRemove}
									/>
								</div>
								<div
									name="accordion-data"
									className={`accordion-data padding-m--inline ${
										index === selectedIndex && "expanded padding-m--top"
									}`}
									// style={{ overflow: "hidden" }}
								>
									<p className="w600 padding-xs--bottom border--bottom border--thick border--red margin-m--bottom">
										Clients {`(${CLIENTS.length})`}
									</p>
									<div
										className="flex flex--column gap-l scroll-bar scroll-bar--overflow padding-m--right"
										style={{ maxHeight: "30vh" }}
									>
										{CLIENTS.map((client, index) => {
											// const company = client.companyType === 0 ? client : client.company;
											return (
												<Company
													key={index}
													client={client}
													accountantList={accountants}
													selectedAccountant={fullName}
												/>
											);
										})}
									</div>
								</div>
							</Fragment>
						);
					})}
				</div>

				{isAdmin && (
					<button onClick={handleOpenModal} className="size400 w600 text-left">
						+ {t("add new member")}
					</button>
				)}
			</div>
			{isNewMemberModalVisible && (
				<NewProfileModal dismiss={handleCloseModal} color={color} onSave={handleAddNewMember} />
			)}
		</div>
	);
};

export default People;
